export const userPreferencesKeys = {
  all: ["user-preferences"] as const,
  byUser: (userId: string) => [...userPreferencesKeys.all, userId] as const,
};
